export default (temperature) => temperature * 9 / 5 + 32
